import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { i18n } from "i18next";
import "./style.scss";

type Props = {
  onDelete: () => void;
  onCloseModal: () => void;
  title?: string;
  loading?: boolean;
  provider: {
    logoUrl: string;
    name: {
      en: string;
      ar?: string;
    };
  };
};

export const DeleteConfirmation = ({
  title,
  loading,
  provider,
  onDelete,
  onCloseModal,
}: Props) => {
  const { t, i18n } = useTranslation();

  if (!provider) return null;

  return (
    <Modal className="delete-provider-modal" open closable={false}>
      <h2>
        {t("shared.delete")} {title || t("shared.providers")}
      </h2>
      <p>
        {t("shared.deleteConfirmation", {
          title: title || t("shared.provider"),
        })}
      </p>
      <div className="provider-details-details">
        <span>
          <img
            src={provider.logoUrl || "/assets/providers/mokhtabar.png"}
            alt="logo-url"
            onError={(e) => {
              (e.target as HTMLImageElement).src =
                "/assets/providers/mokhtabar.png";
            }}
          />
        </span>
        <p>{provider.name[i18n.language as "en" | "ar"]}</p>
      </div>
      <div className="modal-action">
        <Button loading={loading} onClick={onDelete} type="primary">
          {t("shared.delete")}
        </Button>
        <Button onClick={onCloseModal} type="default">
          {t("shared.cancel")}
        </Button>
      </div>
    </Modal>
  );
};
